
import { v4 as uuidv4 } from "uuid";
import { 
  IStringNumHash 
} from "@models";
import { 
  Summon,
  AbilityScores,
  HitDiceWithUsed, 
  CharacterFeature,
  DamageMultiplier,
  SummonFeature,
  CharacterAbility,
  Creature,
  CreatureHP,
  CharacterResourceHolder,
  CharacterSubscriptionHolder,
  CharacterCondition,
  CreatureAbility,
  iCreatureSpell,
  CreatureDetails,
  MinionAbility,
  Ability
} from "@dndModels";
// import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";
import { AbilityScoreType, CreatureType, DamageType, isCreatureType, SizeType, SpellLevel } from "@dndModels/Types";
import { SIZE_MAP, SIZE_TO_NUM_MAP } from "@dndModels/Constants";

// const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

export class SummonInstance implements CreatureDetails {
  true_id = "";
  name = "";
  description = "";
  subscription_holder: CharacterSubscriptionHolder = new CharacterSubscriptionHolder();
  changed() {
    this.subscription_holder.characterChanged();
  }
  stat_block_id = "";
  summon?: Summon;
  spell_id = "";
  spell_true_id = "";
  creature_id = "";
  connected = false;
  is_new = true;
  base_slot_level: SpellLevel = -1;
  slot_level: SpellLevel = -1;
  image_url = "";
  // home
  use_your_pb = false;
  your_pb = 0;
  challenge_rating = 0;
  get use_challenge_rating() {
    return this.challenge_rating;
  }
  get creature_type_string() {
    if (this.swarm) {
      return `Swarm of ${this.size} ${this.creature_type}${this.subtypes.length > 0 ? " (" + this.subtypes.join(" ") + ")" : ""}`;
    } else {
      return `${this.creature_type}${this.subtypes.length > 0 ? " (" + this.subtypes.join(" ") + ")" : ""}`;
    }
  }
  get age_category() {
    return "";
  }
  xp = 0;
  override_creature_type?: CreatureType;
  creature_type: CreatureType = "None"; // Beast, Dragon, Humanoid, etc.
  subtypes: string[] = []; // Drow, Bronze, etc.
  get tags() {
    const tags: string[] = [];
    if (this.summon) {
      tags.push(...this.summon.tags);
    }
    return tags;
  }
  swarm: boolean = false;

  hit_dice_bonus = 0;

  resource_holder: CharacterResourceHolder = new CharacterResourceHolder();
  get hp() {
    return this.resource_holder.hp;
  }
  get hit_dice() {
    return this.resource_holder.hit_dice;
  }
  extra_hp_pools: CreatureHP[] = [];

  share_initiative = false;
  initiative_modifier = 0;
  armor_class = 0;
  get use_ac() {
    return this.armor_class;
  }
  size_num: SizeType = 3;
  get size() {
    return SIZE_MAP[this.size_num];
  };

  get use_size() {
    return this.size_num;
  }
  alignment = "";
  // attributes
  current_speed: IStringNumHash = {};
  speed: IStringNumHash = {};
  get flying() {
    return !!this.current_speed.fly && this.current_speed.fly > 0;
  }
  get swimming() {
    return !!this.current_speed.swim && this.current_speed.swim > 0;
  }
  current_senses: IStringNumHash = {};
  senses: IStringNumHash = {};

  favorite_conditions: string[] = [];
  // condition_hash: { [id: string]: { level: number, source_true_id: string } } = {};
  condition_immunities: string[] = [];
  conditions: CharacterCondition[] = [];

  get condition_hash() {
    const hash:{ [id: string]: { level: number, source_true_id: string } } = {};
    for (const cc of this.conditions) {
      hash[cc.source_id] = { level: cc.level, source_true_id: cc.condition_source_true_id };
    }
    return hash;
  }

  damage_multipliers: DamageMultiplier[] = [];
  tool_proficiencies: string[] = [];
  // skill_proficiencies: IStringNumHash = {};
  skill_proficiencies2: { skill_id: string, prof_level: number, skill_name: string, modifier: number }[] = [];
  saving_throws: {
    STR: number,
    DEX: number,
    CON: number,
    INT: number,
    WIS: number,
    CHA: number
  } = {
    STR: 0,
    DEX: 0,
    CON: 0,
    INT: 0,
    WIS: 0,
    CHA: 0
  };
  languages = "";
  
  current_ability_scores: AbilityScores = new AbilityScores();
  ability_scores: AbilityScores = new AbilityScores();

  actions: CharacterFeature[] = [];
  legendary_actions: CharacterFeature[] = [];
  lair_actions: CharacterFeature[] = [];
  traits: CharacterFeature[] = [];
  
  abilities: CharacterAbility[] = []; 
  // This is just a holder for special resources used to tie it to the actions
  // Currently not fully implemented for SummonInstance.

  get action_cfs() {
    return this.actions.filter(o => 
      !(o.floating_feature instanceof MinionAbility || 
        o.floating_feature instanceof CreatureAbility || 
        o.floating_feature instanceof Ability) || 
      (o.floating_feature.casting_time !== "BA" && o.floating_feature.casting_time !== "RA"));
  }
  get bonus_actions() {
    return this.actions.filter(o => 
      (o.floating_feature instanceof MinionAbility || 
        o.floating_feature instanceof CreatureAbility || 
        o.floating_feature instanceof Ability) && 
      o.floating_feature.casting_time === "BA");
  }
  get reactions() {
    return this.actions.filter(o => 
      (o.floating_feature instanceof MinionAbility || 
        o.floating_feature instanceof CreatureAbility || 
        o.floating_feature instanceof Ability) && 
      o.floating_feature.casting_time === "RA");
  }

  source_true_id = "";
  source_type = "";
  source_name = "";
  root_id = "";
  root_type = "";
  root_name = "";
  cf_true_id = "";
  extra_attacks = 0;
  extra_attacks_string = "";

  use_resources: {
    resource_id: string, // Can be "Slot:Level" or "Pact:Level"
    used: number,
    total: number
  }[] = [];

  get proficiency_modifier() {
    if (this.use_your_pb && this.your_pb > 0) {
      return this.your_pb;
    }
    return common_util.proficiencyBonus(this.challenge_rating);
  }

  get creature(): Creature | undefined {
    return undefined;
  }

  get spellcasting_description(): string {
    return "";
  }

  get use_spells(): iCreatureSpell[] {
    return [];
  }

  get use_slots2(): {
    resource_id: string, // Can be "Slot:Level" or "Pact:Level"
    used: number,
    total: number
  }[] {
    return [];
  }

  get legendary_actions_per_round(): number {
    return 0;
  }

  get legendary_resistances(): number {
    return 0;
  }

  get used_legendary_resistances() {
    return 0;
  }

  get used_legendary_actions() {
    return 0;
  }

  get_speed(type: string): number {
    const the_speed = (this.speed as any)[type];
    if (the_speed) {
      return the_speed;
    }
    return 0;
  }

  get cgift_ids(): string[] {
    return [];
  }

  notes = "";

  constructor(obj?: any) {
    this.true_id = obj ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.is_new = false;
      this.stat_block_id = obj.stat_block_id ? obj.stat_block_id : "";
      this.spell_id = obj.spell_id ? obj.spell_id : "";
      this.spell_true_id = obj.spell_true_id ? obj.spell_true_id : "";
      this.creature_id = obj.creature_id ? obj.creature_id : "";
      this.base_slot_level = obj.base_slot_level ? obj.base_slot_level : -1;
      this.slot_level = obj.slot_level ? obj.slot_level : -1;
      this.name = obj.name ? obj.name : "";
      this.description = obj.description ? obj.description : "";
      (this.creature_type as string) = obj.creature_type ? obj.creature_type : (obj.type ? obj.type : "");
      if (!isCreatureType(this.creature_type)) {
        this.creature_type = "None";
      }
      this.subtypes = obj.subtypes ? obj.subtypes : [];
      this.swarm = obj.swarm ? obj.swarm : false;
      if (this.subtypes.length === 0 && obj.subtype) {
        const subtype = obj.subtype ? obj.subtype : "";
        if (subtype !== "") {
          this.subtypes.push(subtype);
        }
      }
      this.use_your_pb = obj.use_your_pb ? obj.use_your_pb : false;
      this.challenge_rating = obj.challenge_rating ? obj.challenge_rating : 0;
      this.image_url = obj.image_url ? obj.image_url : "";
      this.current_ability_scores = obj.current_ability_scores ? new AbilityScores(obj.current_ability_scores) : new AbilityScores();
      this.ability_scores = obj.ability_scores ? new AbilityScores(obj.ability_scores) : new AbilityScores();
      this.actions = [];
      if (obj.actions && obj.actions.length > 0) {
        obj.actions.forEach((o: any) => {
          if (o.summonFeature) {
            this.actions.push(new SummonFeature(o));
          } else {
            this.actions.push(new CharacterFeature(o));
          }
        });
      }
      this.legendary_actions = [];
      if (obj.legendary_actions && obj.legendary_actions.length > 0) {
        obj.legendary_actions.forEach((o: any) => {
          this.legendary_actions.push(new CharacterFeature(o));
        });
      }
      this.traits = [];
      if (obj.special_abilities && obj.special_abilities.length > 0) {
        obj.special_abilities.forEach((o: any) => {
          this.traits.push(new CharacterFeature(o));
        });
      }

      // console.log(obj);
      if (obj.resource_holder) {
        this.resource_holder = new CharacterResourceHolder(obj.resource_holder);
      } else {
        this.resource_holder = new CharacterResourceHolder();
        this.resource_holder.hp = obj.hp ? new CreatureHP(obj.hp) : new CreatureHP();
        this.resource_holder.hit_dice = []; 
        if (obj.hit_dice) {
          if (obj.hit_dice.length) {
            obj.hit_dice.forEach((hd: any) => {
              this.resource_holder.hit_dice.push(new HitDiceWithUsed(hd));
            });
          } else {
            this.resource_holder.hit_dice.push(new HitDiceWithUsed(obj.hit_dice));
          }
        }
      }
      this.hit_dice_bonus = obj.hit_dice_bonus ? obj.hit_dice_bonus : 0;

      this.current_speed = obj.current_speed ? obj.current_speed : {
        walk: 0,
        swim: 0,
        climb: 0,
        fly: 0,
        burrow: 0,
        hover: 0
      };
      this.speed = obj.speed ? obj.speed : {
        walk: 0,
        swim: 0,
        climb: 0,
        fly: 0,
        burrow: 0,
        hover: 0
      };
      this.saving_throws = obj.saving_throws ? obj.saving_throws : {
        STR: 0, DEX: 0, CON: 0, 
        INT: 0, WIS: 0, CHA: 0
      };
      this.languages = obj.languages ? obj.languages : "";
      this.tool_proficiencies = obj.tool_proficiencies && obj.tool_proficiencies.length > 0 ? obj.tool_proficiencies : [];
      // this.skill_proficiencies = obj.skill_proficiencies ? obj.skill_proficiencies : {};
      this.skill_proficiencies2 = obj.skill_proficiencies2 ? obj.skill_proficiencies2 : [];
      this.share_initiative = obj.share_initiative ? obj.share_initiative : false;
      this.initiative_modifier = obj.initiative_modifier ? obj.initiative_modifier : 0;
      this.armor_class = obj.armor_class ? obj.armor_class : 0;
      this.size_num = obj.size_num ? obj.size_num : (obj.size ? SIZE_TO_NUM_MAP[obj.size] : 3);
      this.alignment = obj.alignment ? obj.alignment : "Neutral";
      this.xp = obj.xp ? obj.xp : 0;
      
      this.favorite_conditions = obj.favorite_conditions ? obj.favorite_conditions : [];
      // this.condition_hash = {};
      // if (obj.condition_hash) {
      //   const cond_ids = Object.keys(obj.condition_hash);
      //   for (const cond_id of cond_ids) {
      //     if (typeof obj.condition_hash[cond_id] === "object") {
      //       this.condition_hash[cond_id] = obj.condition_hash[cond_id];
      //     } else {
      //       this.condition_hash[cond_id] = { level: obj.condition_hash[cond_id], source_true_id: "" };
      //     }
      //   }
      // }
      this.conditions = [];
      if (obj && obj.conditions) {
        for (let i = 0; i < obj.conditions.length; i++) {
          const cc = new CharacterCondition(obj.conditions[i]);
          this.conditions.push(cc);
        }
      }

      this.condition_immunities = obj.condition_immunities ? obj.condition_immunities : [];
      
      this.damage_multipliers = [];
      if (obj.damage_multipliers && obj.damage_multipliers.length > 0) {
        obj.damage_multipliers.forEach((dm: any) => {
          this.damage_multipliers.push(new DamageMultiplier(dm));
        });
      }
      this.senses = {};
      if (obj.senses) {
        if (obj.senses.length > 0) {
          obj.senses.forEach((sense: any) => {
            console.log(sense);
            // this.senses[sense.name] = sense.range;
            // this.senses.push(new CharacterSense(sense));
          });
        } else {
          this.senses = obj.senses;
        }
      }
      this.current_senses = {};
      if (obj.current_senses) {
        if (obj.current_senses.length > 0) {
          obj.current_senses.forEach((sense: any) => {
            console.log(sense);
            // this.senses[sense.name] = sense.range;
            // this.current_senses.push(new CharacterSense(sense));
          });
        } else {
          this.current_senses = obj.current_senses;
        }
      }
      this.source_true_id = obj.source_true_id ? obj.source_true_id : "";
      this.source_name = obj.source_name ? obj.source_name : "";
      this.source_type = obj.source_type ? obj.source_type : "";
      this.root_id = obj.root_id ? obj.root_id : "";
      this.root_name = obj.root_name ? obj.root_name : "";
      this.root_type = obj.root_type ? obj.root_type : "";
      this.cf_true_id = obj.cf_true_id ? obj.cf_true_id : "";

      this.notes = obj.notes ? obj.notes : "";
    }
  }
  get min_challenge_rating() { return this.challenge_rating; }
  get max_challenge_rating() { return this.challenge_rating; }
  get _id() { return this.creature?._id??""; }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      stat_block_id: this.stat_block_id,
      spell_id: this.spell_id,
      spell_true_id: this.spell_true_id,
      creature_id: this.creature_id,
      base_slot_level: this.base_slot_level,
      slot_level: this.slot_level,
      instance_type: "Summon",
      name: this.name,
      description: this.description,
      creature_type: this.creature_type,
      subtypes: this.subtypes,
      swarm: this.swarm,
      image_url: this.image_url,
      current_ability_scores: this.current_ability_scores.toDBObj(),
      ability_scores: this.ability_scores.toDBObj(),
      hit_dice_bonus: this.hit_dice_bonus,
      actions: this.actions.map(o => o.toDBObj()),
      legendary_actions: this.legendary_actions.map(o => o.toDBObj()),
      special_abilities: this.traits.map(o => o.toDBObj()),
      use_your_pb: this.use_your_pb,
      challenge_rating: this.challenge_rating,
      resource_holder: this.resource_holder.toDBObj(),
      current_speed: this.current_speed,
      speed: this.speed,
      saving_throws: this.saving_throws,
      // skill_proficiencies: this.skill_proficiencies,
      skill_proficiencies2: this.skill_proficiencies2,
      tool_proficiencies: this.tool_proficiencies,
      share_initiative: this.share_initiative,
      initiative_modifier: this.initiative_modifier,
      armor_class: this.armor_class,
      size_num: this.size_num,
      alignment: this.alignment,
      xp: this.xp,
      favorite_conditions: this.favorite_conditions,
      // condition_hash: this.condition_hash,
      conditions: this.conditions.map(o => o.toDBObj()),
      condition_immunities: this.condition_immunities,
      damage_multipliers: this.damage_multipliers,
      languages: this.languages,
      source_true_id: this.source_true_id,
      source_name: this.source_name,
      source_type: this.source_type,
      root_id: this.root_id,
      root_name: this.root_name,
      root_type: this.root_type,
      cf_true_id: this.cf_true_id,
      notes: this.notes,
    };
  }

  get_use_name(): string {
    return this.name;
  }

  get hit_dice_string(): string {
    let response = "";
    let hd_bonus = 0;
    for (const hd of this.hit_dice) {
      if (response.length > 0) {
        response += ", ";
      }
      response += `${hd.count}d${hd.size}`;
      hd_bonus += hd.count * this.hit_dice_bonus;
    }
    if (hd_bonus !== 0) {
      response += ` ${common_util.addPlusMaybe(hd_bonus)}`;
    }
    return response;
  }

  // get skills_string(): string {
  //   let response = "";
  //   Object.keys(this.skill_proficiencies).forEach(key => {
  //     if (response.length > 0) {
  //       response += ", ";
  //     }
  //     response += `${key}: ${this.skill_proficiencies[key]}`;
  //   });
  //   return response;
  // }

  get skills_string(): string {
    return this.skill_proficiencies2.map(o => { return `${o.skill_name}: ${o.modifier < 0 ? o.modifier : "+" + o.modifier}`; }).join(", ");
  }

  get tools_string(): string {
    return this.tool_proficiencies.join(", ");
  }

  get senses_string() {
    let response = "";
    Object.keys(this.current_senses).forEach(key => {
      if (response.length > 0) {
        response += ", ";
      }
      response += `${key} ${this.current_senses[key]} ft.`;
    });
    return response;
  }
  get passive_perception() {
    let passive_perception = 10 + this.current_ability_scores.WIS;
    const perception = this.skill_proficiencies2.find(o => o.skill_id === "5fef742e7494ba20cca8a9ec" || o.skill_id === "Perception");
    if (perception) {
      passive_perception += this.proficiency_modifier * perception.prof_level;
    }
    return passive_perception;
  }
  get small_name() {
    return this.creature ? this.creature.small_name : this.name;
  }

  get saving_throws_string(): string {
    let response = "";
    if (this.saving_throws.STR !== 0) {
      if (response.length > 0) {
        response += ", ";
      }
      response += `STR: ${this.saving_throws.STR}`;
    }
    if (this.saving_throws.DEX !== 0) {
      if (response.length > 0) {
        response += ", ";
      }
      response += `DEX: ${this.saving_throws.DEX}`;
    }
    if (this.saving_throws.CON !== 0) {
      if (response.length > 0) {
        response += ", ";
      }
      response += `CON: ${this.saving_throws.CON}`;
    }
    if (this.saving_throws.INT !== 0) {
      if (response.length > 0) {
        response += ", ";
      }
      response += `INT: ${this.saving_throws.INT}`;
    }
    if (this.saving_throws.WIS !== 0) {
      if (response.length > 0) {
        response += ", ";
      }
      response += `WIS: ${this.saving_throws.WIS}`;
    }
    if (this.saving_throws.CHA !== 0) {
      if (response.length > 0) {
        response += ", ";
      }
      response += `CHA: ${this.saving_throws.CHA}`;
    }
    return response;
  }

  get_saving_throw(ability: AbilityScoreType) {
    let modifier: number | null | undefined = (this.saving_throws as any)[ability];
    if (!modifier) {
      modifier = this.current_ability_scores.getModifier(ability);
    }
    if (!modifier) {
      return 0
    } else {
      return modifier;
    }
  }
  saving_throw(ability: AbilityScoreType) {
    return this.get_saving_throw(ability);
  }

  get speed_string(): string {
    let response = "";
    Object.keys(this.current_speed).forEach(key => {
      if (this.current_speed[key]) {
        if (response.length > 0) {
          response += ", ";
        }
        if (key === "hover") {
          if (this.current_speed[key] === 1) {
            response += "hover";
          } else {
            response += "no hover";
          }
        } else {
          response += `${key} ${this.current_speed[key]} ft.`;
        }
      }
    });
    return response;
  }

  get immunities_string(): string {
    // let return_me = "";
    // for (const dm of this.damage_multipliers.filter(o => o.multiplier === 0)) {
    //   for (const dt of dm.damage_types) {
    //     if (return_me.length > 0) {
    //       return_me += ", ";
    //     }
    //     return_me += dt;
    //   }
    // }
    // return return_me;
    return common_util.customJoin({ arr: this.getDTsForMultiplier(0), separator: ", ", lastSeparator: ", and ", onlySeparator: " and "});
  }

  get condition_immunities_string(): string {
    return this.condition_immunities.join(", ");
  }

  get resistances_string(): string {
    return common_util.customJoin({ arr: this.getDTsForMultiplier(0.5), separator: ", ", lastSeparator: ", and ", onlySeparator: " and "});
  }

  get vulnerabilities_string(): string {
    return common_util.customJoin({ arr: this.getDTsForMultiplierSimple(2), separator: ", ", lastSeparator: ", and ", onlySeparator: " and "});
  }

  getDTsForMultiplier(multiplier: number) {
    let dts = this.getDTsForMultiplierSimple(multiplier);
    if (multiplier === 0) {
      dts.push(...this.getUpgradedDTs());
    } else if (multiplier === 0.5) {
      const immune = this.getDTsForMultiplier(0);
      dts = dts.filter(dt => !immune.includes(dt));
    } 
    return common_util.unique_array(dts);
  }

  getDTsForMultiplierSimple(multiplier: number) {
    return common_util.unique_array(this.damage_multipliers.filter(o => o.multiplier === multiplier).flatMap(o => o.damage_types));
  }

  getUpgradedDTs() {
    const upgraded: DamageType[] = [];
    const res_dms = this.damage_multipliers.filter(o => o.multiplier === 0.5 && o.multiplier_improvement);
    for (const dm of res_dms) {
      // Look for another dm for the same type which is also resistance.
      for (const dt of dm.damage_types) {
        const other_dm = this.damage_multipliers.find(o => o.damage_types.includes(dt) && o._id !== dm._id && o.multiplier === 0.5);
        if (other_dm && !upgraded.includes(dt)) {
          upgraded.push(dt);
        }
      }
    }
    return upgraded;
  }

  get true_max_hit_points() {
    return this.hp.true_max;
  }

  clone(): SummonInstance {
    return new SummonInstance(this);
  }

  copy(copyMe: SummonInstance): void {
    // this.true_id = copyMe.true_id;
    this.name = copyMe.name;
    this.true_id = copyMe.true_id;
    this.source_name = copyMe.source_name;
    this.source_type = copyMe.source_type;
    this.source_true_id = copyMe.source_true_id;
    this.root_id = copyMe.root_id;
    this.root_name = copyMe.root_name;
    this.root_type = copyMe.root_type;
    this.cf_true_id = copyMe.cf_true_id;
    this.stat_block_id = copyMe.stat_block_id;
    this.summon = copyMe.summon;
    this.spell_id = copyMe.spell_id;
    this.spell_true_id = copyMe.spell_true_id;
    this.description = copyMe.description;
    this.creature_type = copyMe.creature_type;
    this.subtypes = [...copyMe.subtypes];
    this.swarm = copyMe.swarm;
    this.current_ability_scores = new AbilityScores(copyMe.current_ability_scores);
    this.ability_scores = new AbilityScores(copyMe.ability_scores);
    this.image_url = copyMe.image_url;
    this.use_your_pb = copyMe.use_your_pb;
    this.challenge_rating = copyMe.challenge_rating;

    this.resource_holder = copyMe.resource_holder.clone();
    this.hit_dice_bonus = copyMe.hit_dice_bonus;

    this.current_speed = {...copyMe.current_speed};
    this.speed = {...copyMe.speed};
    this.saving_throws = {...copyMe.saving_throws};
    // this.skill_proficiencies = {...copyMe.skill_proficiencies};
    this.skill_proficiencies2 = copyMe.skill_proficiencies2.map(o => { return { ...o }; });
    this.tool_proficiencies = {...copyMe.tool_proficiencies};
    this.share_initiative = copyMe.share_initiative;
    this.initiative_modifier = copyMe.initiative_modifier;
    this.armor_class = copyMe.armor_class;
    this.actions = [];
    if (copyMe.actions && copyMe.actions.length > 0) {
      copyMe.actions.forEach((o: any) => {
        this.actions.push(new CharacterFeature(o));
      });
    }
    this.legendary_actions = [];
    if (copyMe.legendary_actions && copyMe.legendary_actions.length > 0) {
      copyMe.legendary_actions.forEach((o: any) => {
        this.legendary_actions.push(new CharacterFeature(o));
      });
    }
    this.traits = [];
    if (copyMe.traits && copyMe.traits.length > 0) {
      copyMe.traits.forEach((o: any) => {
        this.traits.push(new CharacterFeature(o));
      });
    }
    this.size_num = copyMe.size_num;
    this.alignment = copyMe.alignment;
    this.xp = copyMe.xp;
    
    this.favorite_conditions = [...copyMe.favorite_conditions];
    // this.condition_hash = {...copyMe.condition_hash};
    this.conditions = copyMe.conditions.map(o => o.clone());
    this.condition_immunities = [...copyMe.condition_immunities];

    this.damage_multipliers = [];
    if (copyMe.damage_multipliers && copyMe.damage_multipliers.length > 0) {
      copyMe.damage_multipliers.forEach((dm: any) => {
        this.damage_multipliers.push(new DamageMultiplier(dm));
      });
    }
    this.languages = copyMe.languages;
    this.senses = { ...copyMe.senses };
    this.current_senses = { ...copyMe.senses };
    this.notes = copyMe.notes;
  }
}